





























import Vue from 'vue';
import { Location } from '../types';
import repository from './location-repository';

interface Data {
  selectedCountry: Location|null,
  selectedCity: Location|null,
  countries: Location[],
  countryTask: Promise<Location[]>|null,
  countryLoading: boolean,
  cities: Location[],
  cityTask: Promise<Location[]>|null,
  cityLoading: boolean,
}

export default Vue.extend({
  props: {
    required: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      selectedCountry: null,
      selectedCity: null,
      countries: [],
      countryTask: null,
      countryLoading: false,
      cities: [],
      cityTask: null,
      cityLoading: false,
    };
  },
  watch: {
    selectedCountry: {
      handler(): void {
        this.loadCities();
      },
      immediate: true,
    },
    countryTask: {
      handler(newTask) {
        if (!newTask) return;
        this.countryLoading = true;
        newTask.finally(() => {
          this.countryLoading = false;
        });
      },
      immediate: true,
    },
    cityTask: {
      handler(newTask) {
        if (!newTask) return;
        this.cityLoading = true;
        newTask.finally(() => {
          this.cityLoading = false;
        });
      },
      immediate: true,
    },
  },
  methods: {
    getRules(errorMessage: string) {
      if (!this.required) return [];
      return [val => !!val || errorMessage];
    },
    selectCountry(location: Location): void {
      this.selectedCountry = location;
      this.$emit('input', this.selectedCountry.id);
    },
    selectCity(location: Location): void {
      this.selectedCity = location;
      this.$emit('input', this.selectedCity.id);
    },
    loadCountries(): void {
      this.countryTask = repository.findAll(null);
      this.countryTask.then((locations: Location[]) => {
        this.countries = locations;
      });
    },
    loadCities(): void {
      if (!this.selectedCountry) return;
      this.cityTask = repository.findAll(this.selectedCountry.id);
      this.cityTask.then((locations: Location[]) => {
        this.cities = locations;
      });
    },
  },
  created(): void {
    this.loadCountries();
  },
});
